import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getVenueParams = (venueAppId) => (
  venueAppId ? { venue_app_id: venueAppId } : {}
);

export const fetchSelectedVenueApplication = async (venueAppId) => {
  const res = await axios.get(`${API}/venue/applications/my`, {
    headers: getAuthHeaders(),
    params: getVenueParams(venueAppId),
  });
  return res.data?.application || null;
};

export const saveSelectedVenueApplication = async (payload, venueAppId) => {
  const res = await axios.post(
    `${API}/venue/applications`,
    {
      ...payload,
      ...(venueAppId ? { app_id: venueAppId } : {}),
    },
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const deleteVenue = async (venueAppId, { password, confirmation, reason }) => {
  const res = await axios.post(
    `${API}/venue/applications/${venueAppId}/delete`,
    { password, confirmation, reason: reason || null },
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const cancelVenueDeletion = async (venueAppId, { password }) => {
  const res = await axios.post(
    `${API}/venue/applications/${venueAppId}/cancel-deletion`,
    { password },
    { headers: getAuthHeaders() }
  );
  return res.data;
};